import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { bool, node, number } from 'prop-types';
import { Container } from './collapse.styles';

const Collapse = _ref => {
  let {
    children,
    trigger,
    collapsedIn
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "trigger", "collapsedIn"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    trigger: trigger,
    collapsedIn: collapsedIn + 1,
    "data-testid": "collapse"
  }, props), React.Children.toArray(children).map(element => /*#__PURE__*/React.isValidElement(element) && /*#__PURE__*/React.cloneElement(element)));
};

process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  trigger: bool,
  children: node,
  collapsedIn: number
} : void 0;
Collapse.defaultProps = {
  trigger: false,
  children: null,
  collapsedIn: 0
};
Collapse.displayName = 'Collapse';
export default Collapse;